import { NavLink, useLocation } from "react-router-dom";
import UtilsService from '../Services/UtilsService';
import { useEffect, useState } from "react";
import TagService from "../Services/TagService";

function InboxThreadRow({ email, onClick, row, lastRowClicked }) {

    let isUnread = email.last_labels && email.last_labels.includes('UNREAD');

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const search = params.toString();

    const [localLabels, setLocalLabels] = useState([]);

    useEffect(() => {

        if (email.local_labels && email.local_labels.length > 0) {
            normalizeLocalLabels();
        }

    }, [email]);

    async function normalizeLocalLabels() {

        let labelsPromise = email.local_labels.map(async (label) => {
            let color = await TagService.getColorForTag(label);
            return {
                name: label,
                color: color
            };
        });

        let labels = await Promise.all(labelsPromise);
        setLocalLabels(labels);

    }



    function handleOnClick(e) {
        e.stopPropagation();
        onClick(row);
    }

    function renderLocalLabels() {

        return localLabels.map(({ name, color }, index) => {
            return (
                <span key={index} className="badge badge-inbox me-2" style={{ backgroundColor: color }}>{name}</span>
            )
        });
    }

    const uniqueEmailRecipients = Array.from(new Set(email.recipients))

    const directionIcon = email.last_message_from_account ? 'fa-paper-plane' : 'fa-inbox';
    const directionText = email.last_message_from_account ? 'Sent' : 'Received';
    const directionClass = email.last_message_from_account ? 'text-primary' : 'text-danger';

    return (
        <li
            class={"list-group-item list-group-item-action inbox-email-row " + (row && row === lastRowClicked ? 'active' : '')}>
            <div
                data-tooltip-id="inbox-tooltip"
                data-tooltip-content="Select"
                className="inbox-email-checkbox">
                <input className="form-check-input"
                    type="checkbox" id={`${email.date}-checkbox`} value={true} />
            </div>

            <div
                data-tooltip-id="inbox-tooltip"
                data-tooltip-content="Mark as starred"
                className="inbox-email-star">
                <i className="fa-regular fa-star"></i>
            </div>

            <div className="inbox-email-direction"
                data-tooltip-id="inbox-tooltip"
                data-tooltip-content={directionText}
            >
                <i className={`fa-solid ${directionIcon} ${directionClass} me-1`}></i>
            </div>


            <NavLink
                onClick={handleOnClick}
                to={`/admin/inbox/${email.thread_id}?${search}`}
                className="inbox-email-from">
                <span className={isUnread ? 'bold' : ''}>{uniqueEmailRecipients}</span>
            </NavLink>

            <span
                data-tooltip-id="inbox-tooltip"
                data-tooltip-content={email.account}
                class="badge badge-inbox me-2">{email.initials}
            </span>

            {renderLocalLabels()}

            <NavLink
                onClick={handleOnClick}
                to={`/admin/inbox/${email.thread_id}?${search}`}
                className="inbox-email-subject">

                <span className={isUnread ? 'bold' : ''}>{email.subject}</span> -
                <span style={{ color: "gray" }}>{email.snippet}</span>
            </NavLink>

            <div className="inbox-email-date">
                {UtilsService.formatDateForInbox(email.last_message_date)}
            </div>

            <div className="inbox-hide-actions">
                <button
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Archive"
                >
                    <i className="fa-solid fa-box-archive"></i>
                </button>
                <button
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Delete"
                >
                    <i className="fa-regular fa-trash-can"></i>

                </button>
                <button data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Mark as unread">
                    <i className="fa-regular fa-envelope"></i>

                </button>

            </div>

        </li>

    )

}

export default InboxThreadRow;